/**
 * Simple class defining basic attributes of the geometrical section Polygon.
 * This represents an SVG Path element
 * @class DataPolygon
 */
export default class DataPolygon {
  constructor (opts) {
    opts = opts || {};

    /**
     * Attributes that are assigned to the section are then passed onto the Path element.
     * This allows developers to target the data attributes from css and javascript
     * defaults to empty array.
     *
     * If, for example, you assign:
     * ```javascript
     * opts.attributes = ['wheelchair-access'];
     * ```
     * It will result in the dom element
     * ```html
     * <path d="..." data-wheelchair-access />
     * ```
     *
     * @type {Array<String>}
     */
    this.attributes = opts.attributes || [];

    /**
     * This is exactly the "d" parameter of the <path> svg element
     * @type {String}
     */
    this.d = opts.d;

    /**
     * @type {Boolean}
     */
    this.isGA = opts.isGA;
  }
}



// WEBPACK FOOTER //
// ./frontend/react/sim/schemas/Polygon.js